<ion-content [scrollEvents]="true" (ionScroll)="onScroll()" scrollY="true" ridangoAppTrapFocus>
    <div class="flex-column flex">
        <div class="bg-white shadow-md dark:bg-contrast-black">
            <div class="grid grid-cols-[4rem_1fr_4rem] py-2">
                <ion-button
                    class="var-app-light:text-primary font-semibold normal-case text-secondary dark:text-contrast-yellow"
                    [attr.aria-label]="'LOCAL_BTN_BACK' | translate"
                    (click)="closeModal()"
                    fill="clear">
                    <ion-icon
                        class="mr-1 text-xl dark:filter-yellow"
                        [attr.aria-label]="'LOCAL_BTN_BACK' | translate"
                        title="{{ 'LOCAL_BTN_BACK' | translate }}"
                        src="{{ assetsPath$ | async }}/img/journey-planner/icon-arrow.svg"></ion-icon>
                </ion-button>
                <h2 class="flex-justify-center flex-align-center flex font-semibold">
                    {{ 'EXPLORE_SEARCH_HEADER' | translate }}
                </h2>
                <div></div>
            </div>

            <div class="p-4 pt-0">
                <ion-searchbar
                    class="rounded-md text-black dark:bg-contrast-yellow"
                    #exploreSearchBar
                    [style.--border-radius]="'0.5rem'"
                    [searchIcon]="(assetsPath$ | async) + '/img/explore/search_icon.svg'"
                    [placeholder]="'EXPLORE_SEARCH_PLACEHOLDER' | translate"
                    [attr.data-high-contrast]="highContrast$ | async"
                    (ionInput)="handleSearchPhraseChange($event)"
                    clearIcon="close-sharp"
                    mode="ios"></ion-searchbar>
            </div>
        </div>

        <div class="sr-only" *ngIf="searchService.searchResultsAnnouncement$ | async" aria-live="assertive">
            {{ searchService.searchResultsAnnouncement$ | async }}
        </div>

        <div
            class="mt-4 bg-white px-4 shadow-md dark:bg-contrast-black"
            *ngIf="recentSearchItems?.length > 0 && !!(searchPhrase$ | async) === false">
            <rwidget-search-recents
                [recents]="recentSearchItems"
                [searchText]="searchText"
                (select)="handleSearchItemSelect($event)"
                (clear)="clearRecentSearchItems()">
            </rwidget-search-recents>
        </div>

        <div
            class="mt-4 bg-white px-4 shadow-md dark:bg-contrast-black"
            *ngIf="
                (searchPhrase$ | async)?.length >= (this.env.SEARCH_SETTINGS?.MINIMUM_SEARCH_CHARACTERS || 1) &&
                (searchResultItems?.stopRoutes.length ||
                    searchResultItems?.addresses.length ||
                    searchResultItems?.poi.length)
            ">
            <ng-container *ngFor="let searchItem of searchResultItems.stopRoutes; let i = index">
                <div
                    class="border-ironside_grey-100 border-t border-solid dark:border-contrast-yellow"
                    *ngIf="i !== 0"></div>
                <rwidget-search-item
                    [searchItem]="searchItem"
                    [searchText]="searchText"
                    (select)="handleSearchItemSelect($event)"></rwidget-search-item>
            </ng-container>

            <ng-container *ngIf="canShowMore('stopRoutes')">
                <div class="border-ironside_grey-100 border-t border-solid dark:border-contrast-yellow"></div>
                <div class="px-10 pb-2">
                    <button
                        class="py-4 text-base font-semibold leading-5 text-primary dark:text-contrast-yellow"
                        (click)="loadMoreItems(TransitNetworkPartType.Stop)"
                        attr.aria-label="{{ 'SHOW_MORE_STOPS' | translate }}"
                        tabindex="0">
                        {{ 'SHOW_MORE_STOPS' | translate }}
                    </button>
                </div>
            </ng-container>

            <ng-container *ngFor="let searchItem of searchResultItems.addresses; let i = index">
                <div
                    class="border-ironside_grey-100 border-t border-solid dark:border-contrast-yellow"
                    *ngIf="
                        searchResultItems.stopRoutes.length || (searchResultItems.stopRoutes.length === 0 && i !== 0)
                    "></div>
                <rwidget-search-item
                    [searchItem]="searchItem"
                    [searchText]="searchText"
                    (select)="handleSearchItemSelect($event)">
                </rwidget-search-item>
            </ng-container>

            <ng-container *ngIf="canShowMore('addresses')">
                <div class="border-ironside_grey-100 border-t border-solid dark:border-contrast-yellow"></div>
                <div class="px-10 pb-2">
                    <button
                        class="py-4 font-semibold leading-5 text-primary dark:text-contrast-yellow"
                        (click)="loadMoreItems(TransitNetworkPartType.Location)"
                        attr.aria-label="{{ 'SHOW_MORE_LOCATIONS' | translate }}"
                        tabindex="0">
                        {{ 'SHOW_MORE_LOCATIONS' | translate }}
                    </button>
                </div>
            </ng-container>

            <ng-container *ngFor="let searchItem of searchResultItems.poi; let i = index">
                <div
                    class="border-ironside_grey-100 border-t border-solid dark:border-contrast-yellow"
                    *ngIf="
                        searchResultItems.stopRoutes.length ||
                        searchResultItems.addresses.length ||
                        (searchResultItems.stopRoutes.length === 0 &&
                            searchResultItems.addresses.length === 0 &&
                            i !== 0)
                    "></div>
                <rwidget-search-item
                    [searchItem]="searchItem"
                    [searchText]="searchText"
                    (select)="handleSearchItemSelect($event)"></rwidget-search-item>
            </ng-container>

            <ng-container *ngIf="canShowMore('poi')">
                <div class="border-ironside_grey-100 border-t border-solid dark:border-contrast-yellow"></div>
                <div class="px-10 pb-2">
                    <button
                        class="py-4 font-semibold leading-5 text-primary dark:text-contrast-yellow"
                        (click)="loadMoreItems(TransitNetworkPartType.POI)"
                        attr.aria-label="{{ 'SHOW_MORE_POI' | translate }}"
                        tabindex="0">
                        {{ 'SHOW_MORE_POI' | translate }}
                    </button>
                </div>
            </ng-container>
        </div>

        <div
            class="mt-8 text-center"
            *ngIf="
                hasSearched &&
                (searchPhrase$ | async) &&
                !searchResultItems?.stopRoutes.length &&
                !searchResultItems?.addresses.length &&
                !searchResultItems?.poi.length &&
                !this.searchLoading
            ">
            <div class="vl-app-light:text-old_silver-lighter my-4 text-grey-dark dark:text-contrast-yellow">
                <svg width="42" height="43" viewBox="0 0 42 43" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M26.2578 29.8187L39.0821 42.643L41.9105 39.8145L29.0862 26.9902L26.2578 29.8187Z"
                        fill="currentColor" />
                    <path
                        d="M17.5111 35.8621C7.82785 35.8621 0 27.8223 0 17.931C0 8.03978 7.82785 0 17.5111 0C27.1943 0 35.0222 8.03978 35.0222 17.931C35.0222 27.8223 27.1943 35.8621 17.5111 35.8621ZM17.5111 31.8621C24.9609 31.8621 31.0222 25.6367 31.0222 17.931C31.0222 10.2254 24.9609 4 17.5111 4C10.0613 4 4 10.2254 4 17.931C4 25.6367 10.0613 31.8621 17.5111 31.8621Z"
                        fill="currentColor" />
                </svg>
            </div>

            <p>{{ 'SEARCH_RESULTS_NOT_FOUND' | translate }}</p>
        </div>

        <div class="bg-white dark:bg-contrast-black" *ngIf="this.searchLoading">
            <div class="flex px-2 pt-2">
                <ridango-ui-skeleton-loader class="w-full" height="2.75rem" count="6"></ridango-ui-skeleton-loader>
            </div>
        </div>
    </div>
</ion-content>
